import { useContext, useEffect, useState } from "react";
import { Formik, Form, FormikProps, getIn } from "formik";
import { Button, Spinner } from "reactstrap";
import "./Login.scss";
import FormInput from "../../../components/FormInput";
import { validationSchema } from "../../../validations/login.validation";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { loginWithUsernameAndPassword } from "../../../services/auth.service";
// import { toast } from "react-hot-toast";
import useLocalStorage from "../../../hooks/useLocalStorage";
import Logo from "../../../assets/images/logo.jpeg";
import FormSelect from "../../../components/FormSelect";
import { getCompanies } from "../../../services/company.service";
import { CompanyContext } from "../../../contexts/CompanyContext";

interface LoginFormValues {
  username: string;
  password: string;
  company: any;
}

function Login() {
  const [, setRefreshToken] = useLocalStorage("refresh-token");

  const [companies, setCompanies] = useState([]);
  const { handleChangeCompany }: any = useContext(CompanyContext);
  const { updateAuthentication } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    getCompanies({}).then((response) => {
      setCompanies(response.data.results);
    });
  }, []);

  // Define the initial form values
  const initialValues: LoginFormValues = {
    username: "",
    password: "",
    company: "",
  };

  // Handle form submission
  const handleSubmit = (
    values: LoginFormValues,
    { setSubmitting }: FormikProps<LoginFormValues>,
  ) => {
    handleChangeCompany(values.company);
    loginWithUsernameAndPassword(values)
      .then((response) => {
        setRefreshToken(response.data.tokens.refresh.token);
        updateAuthentication(true);
        navigate("/");
      })
      .catch(() => {
        setSubmitting(false);
        //toast.error(error.response.data.message);
      });
  };

  return (
    <div className='login-form-container'>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values: any, actions: any) => handleSubmit(values, actions)}
      >
        {(props: FormikProps<LoginFormValues>) => {
          const { values, touched, errors, isSubmitting, handleChange, setFieldValue } = props;
          return (
            <Form className='login-form pt-0'>
              <div className='login-form__welcome-text'>
                <img src={Logo} alt='Logo' className='img-fluid' width={160} />
                <h2>Welcome!</h2>
                <p>Please enter your email to log in</p>
              </div>

              <FormInput
                name='username'
                type='text'
                label='Username'
                placeholder='Username'
                value={values.username}
                onChange={handleChange}
                error={errors.username}
                touched={touched.username}
                // autoFocus
              />
              <FormInput
                name='password'
                type='password'
                label='Password'
                placeholder='Password'
                value={values.password}
                onChange={handleChange}
                error={errors.password}
                touched={touched.password}
                marginBottom='0'
              />

              <FormSelect
                id='company'
                name='company'
                label='Company'
                formGroupClasses='m-0'
                options={companies}
                onChange={(name: string, value: object) => {
                  // handleChangeCompany(value);
                  setFieldValue(name, value);
                }}
                value={getIn(values, "company")}
                error={getIn(errors, "company")}
                touched={getIn(touched, "company")}
              />

              <div className='login-form__button-container'>
                <Button
                  className={isSubmitting ? "login-form__button-container--submitting" : ""}
                  type='submit'
                  color='primary'
                  disabled={isSubmitting}
                  block
                >
                  {isSubmitting ? <Spinner size='sm' /> : "Login"}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default Login;
